import React from 'react';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import SearchIcon from '@material-ui/icons/Search';
import './student_result.css';

function Student_result() {
  return (
    <div>
        <div className="coursessec">
            <div className="introabout">
                <p className="abouttitle">Student Result</p>
                <p className="subabout">Home <span><ArrowForwardIosIcon className='spanicon' /><ArrowForwardIosIcon className='spanicon1' /></span> student result</p>
            </div>
        </div>

        <div className="studentresult">
          <h2 className="Sname">
          Enter Student Roll Number :
          </h2>

          <p className="titleresult">
          For Example : 1245
          </p>
          <div className="searchbtn">
                <SearchIcon className='search' /><input type="text" id='search-input' placeholder="Search here ..." />
                <button className='navbutton'>Search</button>
            </div>
        </div>
        
         </div>
  )
}

export default Student_result